/**
 * Created by Administrador on 26/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('billingModeService',billingModeService);

    billingModeService.$inject = ['$http', 'CONFIG','messageService'];

    function billingModeService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/billingModes';

        var service = {
            getBillingModes: getBillingModes
        };

        return service;

        function getBillingModes(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.billingModes : [];
                }, function(){
                    messageService.findAllError('');
                });
        }
    }
})();
